import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { getRoute } from './routes';
import * as serviceWorker from './serviceWorker';

const rootElement = document.getElementById('root');
const tree = (
  <React.StrictMode>
    {getRoute(window.location.pathname)}
  </React.StrictMode>
);

// If the page was prerendered at build time (see prerender.js), the #root
// already contains server-generated markup — hydrate it in place rather than
// throwing it away and re-rendering (which would flash and lose the SEO win).
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(tree, rootElement);
} else {
  ReactDOM.render(tree, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
